import {
  blue,
  green,
  orange,
  pink,
  purple,
  red,
  yellow,
} from '@mui/material/colors';

import { Metric } from './@types/Models';
export const sciWidth = 50;
export const surveyWidth = 60;
export const largeWidth = 80;
export const mediumWidth = 60;
export const smallWidth = 40;
export const ageWidth = 65;
export const spellWidth = 25;
export const svgStyles = {
  height: spellWidth,
  width: spellWidth,
  padding: '2px 1px',
  fill: '#B0BECF',
};
export const sorcery = 1;
export const thievery = 2;
export const both = 3;
export const specificOp = 4;

export const metrics: Metric[] = [
  { name: 'Acres', context: sorcery },
  { name: 'Peons', context: both },
  { name: 'Horses', context: both },
  { name: 'Gold', context: both },
  { name: 'Food', context: both },
  { name: 'Runes', context: both },
  { name: 'OP count', context: specificOp },
];

export const intelColors = {
  dark: {
    freshest: green[300],
    fresh: green[600],
    older: orange[500],
    oldest: red[500],
  },
  light: {
    freshest: green[400],
    fresh: green[700],
    older: orange[600],
    oldest: red[500],
  },
};

export const autosizeOptions = {
  includeOutliers: true,
  includeHeaders: true,
};
